import {
  ThreadStatus,
  ThreadFilters,
  ThreadItem,
  DEFAULT_FILTERS,
  Thread,
} from '@/models/thread';
import { createContext, Dispatch, RefObject, SetStateAction } from 'react';
import { DeepDiveAutoSelect } from '../hooks/useDeepDiveAutoSelect';

interface ThreadContextProps extends Thread {
  status: ThreadStatus;
  selectedApproach: number;
  setSelectedApproach: Dispatch<SetStateAction<number>>;
  deepDiveAutoSelect: DeepDiveAutoSelect;
  // The prompt box on the page, when there is one
  promptRef: RefObject<HTMLTextAreaElement>;
  setStatus: Dispatch<SetStateAction<ThreadStatus>>;
  handleTitleUpdate: (newTitle: string) => void;
  handlePromptSubmit: (msg: string, filters?: ThreadFilters) => void;
  handleCitationRequest: (item: ThreadItem) => void;
  resetThread: () => void;
}

const ThreadContext = createContext<ThreadContextProps>({
  id: undefined,
  title: '',
  items: [],
  status: 'READY',
  selectedApproach: 0,
  setSelectedApproach: () => {},
  deepDiveAutoSelect: {
    isPending: false,
    isHintVisible: false,
    hideHint: () => {},
    dismissHint: () => {},
    cancel: () => {},
  },
  promptRef: { current: null },
  filters: DEFAULT_FILTERS,
  setStatus: () => ({}),
  handleTitleUpdate: () => ({}),
  handlePromptSubmit: () => ({}),
  handleCitationRequest: () => ({}),
  resetThread: () => ({}),
});

export default ThreadContext;
